
import { Directive, Input, HostBinding, HostListener } from '@angular/core';

type ButtonVariant = 'primary' | 'secondary' | 'ghost';
type ButtonSize = 'sm' | 'md' | 'lg';

@Directive({
  selector: '[appGalaxyButton]',
  standalone: true
})
export class GalaxyButtonDirective {

  @Input('galaxyVariant') variant: ButtonVariant = 'primary';
  @Input('galaxySize') size: ButtonSize = 'md';
  @Input() disabled = false;

  constructor() {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (this.disabled) {
      return;
    }
  }

  @HostBinding('class')
  get hostClasses(): string {
    return [
      'galaxy-button', // a base class for all galaxy buttons
      `galaxy-variant-${this.variant}`,
      `galaxy-size-${this.size}`,
    ].join(' ');
  }

  @HostBinding('class.disabled')
  get isDisabled(): boolean {
    return this.disabled;
  }

  @HostBinding('attr.disabled')
  get attrDisabled(): boolean | null {
    return this.disabled ? true : null;
  }
}
